import React, {Component} from 'react';
import {API_URL} from "../../settings/local_settings";
import {APIClient} from "../../utils/APIClient";
import {YesNoModal} from "../elements/YesNoModal";

export class DeleteInvitationModal extends Component {
    constructor(props) {
        super(props);

        this.handleDelete = this.handleDelete.bind(this);
    }

    handleDelete () {
        new APIClient(API_URL + `invitation/${this.props.invitationId}/delete`).call('GET').then((data) => {
            if (data.status === 'ERROR') {
                alert(data['error_message']);
            }

            this.props.removeDeletedInvitation(this.props.invitationId);
        })
    }

    render() {
        return <YesNoModal onYesAnswer={this.handleDelete}
                           title="Estas a punto de eliminar una invitación"
                           message=""
                           question="¿Estás seguro?"
                           buttonClassName={""}
                           buttonText={""}
                           buttonIconName={"trash"}
        />
    }
}

